import { RefObject, useCallback, useEffect, useState } from 'react';

export const useIsFocused = (elementRef: RefObject<HTMLElement | null | undefined>) => {
  const [isFocused, setIsFocused] = useState(false);

  const onFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const onBlur = useCallback(() => {
    setIsFocused(false);
  }, []);

  useEffect(() => {
    if (!elementRef.current) return;
    const element = elementRef.current;
    element.addEventListener('focus', onFocus);
    element.addEventListener('blur', onBlur);
    return () => {
      element.removeEventListener('focus', onFocus);
      element.removeEventListener('blur', onBlur);
    };
  }, [elementRef, onFocus, onBlur]);

  return isFocused;
};
